import axios from "axios";

export const apiRequest = (data: any) => {
  const baseURL = data.baseURL || process.env.REACT_APP_API_URL;
  const instance = axios.create({
    baseURL,
  });

  instance.interceptors.request.use(
    (config: any) => {
      const token = data?.token
        //|| "eyJraWQiOm51bGwsInR5cCI6IkpXVCIsImFsZyI6IkhTMjU2In0.eyJ1aWQiOjE3MjQzMjA4MTE5OTAzODg3MzgsInJhbmRvbSI6Ijc2NDQyMCIsImlzcyI6Ind3dy5uZWt0ZWNrLmNvbSIsImlhdCI6MTcxNTU3MTMyOCwic3lzdGVtVGltZSI6IjE3MTU1NzEzMjg3MTIifQ.eBykz2FA7Z1dqr-_ZsLSaz9p_94zyLCpf_Ky9UHTVrs";
      if (token) {
       config.headers.Authorization = `${token}`;
        config.headers.Language = data?.lang || "en";
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export const get = (data: any) => {
  const instance = apiRequest(data);
  return instance.get(data.url, { params: data.params });
};

export const post = (data: any) => {
  const instance = apiRequest(data);
  return instance.post(data.url, data.data);
};
